var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-video',{staticStyle:{"max-width":"400px","max-height":"280px"},attrs:{"focused-video":_vm.focusedVideo,"video":_vm.video},on:{"onFocus":function($event){_vm.focusVideo = true}}})
}
var staticRenderFns = []

export { render, staticRenderFns }